import TouchIdBaseScreen from './touch_id_screen_base';
import {TOUCH_ID} from '../touch_id_component_consts';
import {USER_EVENTS} from '../../../../../events/events';
import DOM from '../../../../../utils/dom';
import {SYSTEM_EVENTS} from '../../../../../events/events';
import Event from '../../../../../utils/event';

class TouchIdModifyScreen extends TouchIdBaseScreen {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'TouchIdModifyScreen';
    _selector = 'cgp-touch-id-screen-modify';

    _checkboxToggle = null;

    init(params) {
        super.init(params);
        this._setHtml(TOUCH_ID.MODIFY_VIEW);
    }

    show() {

        super.show();

        DOM.addClass(this.getEl().getElementsByClassName('cgp-touch-id-content')[0], this._selector);

        this.checkToOpenTouchIdSettings();


        return this;
    }

    checkToOpenTouchIdSettings() {

        return new Promise((resolve) => {
            const hybrid = this._parent.serviceFactory.hybridService();

            if (!hybrid.isOpenSettingSupported()) {
                resolve(false);
            }

            hybrid.isDeviceTouchEnable().then(bVal => {
                if (!hybrid._touchidfeature.getModel().isDeviceTouchEnable()) {
                    hybrid.openTouchIdSettings();
                    resolve(true);
                } else {
                    resolve(false);
                }
            });
        });
    }

    onComponentOpened() {
        this._checkboxToggle = this.getEl().querySelector(TOUCH_ID.ELEMENT_CHECKBOX);

        this._parent.checkTouchEnable();

        DOM.onDOMElementEvent(this._checkboxToggle, USER_EVENTS.ON_CHANGE, () => {
            let strToggle = 'Menu toggle on';
            if (this._checkboxToggle?.checked) {

                this.checkToOpenTouchIdSettings().then(bOpen => {
                    if (!bOpen) {
                        this._parent.getTokenFromSrv();
                    } else {
                        this.onCheckTouchEnable(false);
                    }
                });

                this.onInitScreenShow();

            } else {
                strToggle = 'Menu toggle off';
                Event.fire(SYSTEM_EVENTS.TOUCH_ID_CLEAR_TOKEN);
            }

            this._parent.serviceFactory.analyticsService().sendClickstreamEvent(
                {
                    eventName: 'Client_TouchID',
                    category: strToggle
                });

        });
    }

    onCheckTouchEnable(bChecked) {
        this._checkboxToggle.checked = bChecked;
    }

    onClosedByClicked() {
        super.onClosedByClicked();
        Event.fire(SYSTEM_EVENTS.TOUCH_ID_STATE_CHANGED)
    }
}
export default TouchIdModifyScreen;
